/**
 * An 8px score bar (DESIGN.md "Framework tile"): a 0–100 fill on a
 * layer-accent track, in a pillar's mark color when given a category (the
 * Best Practice framework meters), otherwise the strong neutral. A meter for
 * assistive tech, named by `label`.
 */
import clsx from 'clsx'
import { TONE_BG } from './tones'
import type { Category } from './types'

export interface ScoreBarProps {
  /** 0–100; clamped. */
  value: number
  category?: Category
  /** Accessible name ("CISA SCuBA pass rate"). */
  label: string
  className?: string
}

export function ScoreBar({ value, category, label, className }: ScoreBarProps) {
  const pct = Math.min(100, Math.max(0, Number.isFinite(value) ? value : 0))
  return (
    <div
      role="meter"
      aria-label={label}
      aria-valuenow={Math.round(pct)}
      aria-valuemin={0}
      aria-valuemax={100}
      className={clsx('h-2 w-full bg-layer-accent', className)}
    >
      <div className={clsx('h-full', category ? TONE_BG[category] : TONE_BG.strong)} style={{ width: `${pct}%` }} />
    </div>
  )
}

export default ScoreBar
